export default __webpack_public_path__ + "static/media/bg-img5.8435fb27.jpg";